export default __webpack_public_path__ + "static/media/l5-p2.2c3ec715.svg";